import type * as THREE from 'three';

// Runtime identity only; the canonical domain remains the entity owner.
// Keep the indexed source node's local pose while module edits move its
// independent affine carrier. Weak keys follow the loaded scene lifetime.
const carriers = new WeakMap<THREE.Object3D, THREE.Object3D>();

export function registerNativePartCarrier(part: THREE.Object3D, carrier: THREE.Object3D): void {
  carriers.set(part, carrier);
}

export function nativePartCarrier(part: THREE.Object3D): THREE.Object3D | undefined {
  return carriers.get(part);
}
